// Native smooth scrolling (Lenis removed for cross-browser stability)
export function SmoothScroll() {
  return null;
}

// Comic action badge
export function Badge({ children, color = "yellow", className = "", ...props }) {
  const bg =
    color === "magenta"
      ? "bg-[#ff0055] text-white"
      : color === "cyan"
      ? "bg-[#00f0ff] text-black"
      : "bg-[#ffe600] text-black";
  return (
    <span
      className={`badge-skew ${bg} px-3 py-1 text-sm md:text-base border-2 border-black shadow-[3px_3px_0_#000] ${className}`}
      {...props}
    >
      <span>{children}</span>
    </span>
  );
}

// Scroll reveal — CSS-only entrance that ALWAYS ends visible (no JS/observer gating)
export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <div className={`reveal-anim ${className}`} style={{ animationDelay: `${delay}s` }}>
      {children}
    </div>
  );
}

// Headline line — always visible (no transform gating)
export function MaskLine({ children }) {
  return <span className="block">{children}</span>;
}

// Angled glitch divider
export function GlitchDivider({ flip = false }) {
  return (
    <div className="relative h-8 w-full overflow-hidden" aria-hidden>
      <div
        className={`absolute inset-0 ${flip ? "-skew-y-2" : "skew-y-2"}`}
        style={{
          background:
            "repeating-linear-gradient(90deg,#ff0055 0 22px,#08080c 22px 40px,#00f0ff 40px 58px,#08080c 58px 80px)",
          opacity: 0.85,
        }}
      />
    </div>
  );
}
